import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
  font-size: ${props => props.theme.texts.bodyMRegular.fontSize};

  & > div {
    margin-bottom: ${props => props.theme.whiteLabel.spacing.sp16};
  }
`

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};

  padding-top: ${props => props.theme.whiteLabel.spacing.sp24};

  button {
    width: 100%;
  }

  @media screen and (max-width: 500px) {
    flex-direction: column-reverse;
  }
`
